import RoundButton from '@deltek/specification-client/core/Buttons/RoundButton'
import React from 'react'

/**
 * Renders a button to switch back to the previous workspace
 * @param {WorkspaceSwitchButtonProps} props - Component properties
 * @returns {React.ReactElement} Workspace switch button
 */
export const WorkspaceSwitchButton = React.memo<{
    onClick: () => void
    'data-testid'?: string
}>(({ onClick, 'data-testid': dataTestId }) => (
    <RoundButton
        size="medium"
        color="#fff"
        borderColor="#304959"
        backgroundColor="#304959"
        data-testid={dataTestId}
        hoverColor="#091B32"
        onClick={onClick}
    >
        Switch Back Editor
    </RoundButton>
))
